import styled from "styled-components";
import { pageHeroSubtitleSize, pageHeroTitleSize } from "@app/themes/index";

export const PageHeaderWrapper = styled.div`
  width: 100%;
  padding: 6rem 1.5rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  background-color: ${({ $backgroundColor, theme }) =>
    $backgroundColor === "transparent"
      ? "transparent"
      : $backgroundColor || theme.palette.redesign.white};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: 8rem 2rem 4rem;
  }
`;

export const PageHeaderTitle = styled.h1`
  ${pageHeroTitleSize}
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  line-height: 1.15;
  color: ${(props) => props.theme.palette.redesign.black};
  margin: 0;

  em {
    font-family: ${({ theme }) => theme.fonts.display};
    font-style: italic;
    font-weight: normal;
  }
`;

export const PageHeaderSubtitle = styled.p`
  ${pageHeroSubtitleSize}
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  color: ${(props) => props.theme.palette.text.muted};
  max-width: 37.5rem;
  margin: 0;
  line-height: 1.5;
`;
